import { Box, Stack } from '@mui/material'
import { ReactComponent as UserIcon } from 'assets/icons/UserIcon.svg'
import moment from 'moment'
import 'moment/locale/ru'
import { FC } from 'react'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographySecondaryBold14 } from 'ui/typography/TypographySecondaryBold14'
import {
	getDatesInRange,
	getShiftScheduleColumnsSx,
} from './shiftScheduleLayout'

moment.locale('ru')

interface ShiftScheduleHeaderProps {
	dateRange: { startDate: number; endDate: number }
	count: number
	datesOnly?: boolean
	columnWidth?: number
}

export const ShiftScheduleHeader: FC<ShiftScheduleHeaderProps> = ({
	dateRange,
	count,
	datesOnly = false,
	columnWidth,
}) => {
	const dates = getDatesInRange(dateRange.startDate, dateRange.endDate)
	const columnsSx = getShiftScheduleColumnsSx(dates.length, columnWidth)

	return datesOnly ? (
		<Box sx={columnsSx}>
			{dates.map(date => (
				<Box key={date.valueOf()} sx={{ textAlign: 'center' }}>
					<TypographySecondaryBold14
						sx={{ color: COLORS.secondary, textTransform: 'capitalize' }}
					>
						{date.format('dd DD.MM').toUpperCase()}
					</TypographySecondaryBold14>
				</Box>
			))}
		</Box>
	) : (
		<Stack direction='column' gap='12px'>
			<Stack direction='row' alignItems='center' gap={0}>
				<Stack
					direction='row'
					alignItems='center'
					gap='4px'
					sx={{ minWidth: '280px', flexShrink: 0 }}
				>
					<UserIcon />
					<TypographyPrimary>{count}</TypographyPrimary>
				</Stack>

				<Box sx={{ ...columnsSx, flex: 1 }}>
					{dates.map(date => (
						<Box key={date.valueOf()} sx={{ textAlign: 'center' }}>
							<TypographySecondaryBold14
								sx={{ color: COLORS.secondary, textTransform: 'capitalize' }}
							>
								{date.format('dd DD.MM').toUpperCase()}
							</TypographySecondaryBold14>
						</Box>
					))}
				</Box>
			</Stack>
		</Stack>
	)
}
